import { Injectable } from '@angular/core';
import { Funcoes } from '../../funcoes';
import { Headers, Http } from "@angular/http";

declare let PNotify: any;

@Injectable()
export abstract class Service {

  protected abstract func: Funcoes;
  protected abstract http: Http;

  public get dominio(): string {
    return (this.func && this.func.global && this.func.global.dominio_site) ? this.func.global.dominio_site : "https://api-v2.123.com.br";
  }
  protected url: string = "";

  constructor() { }

  get(relacionamentos = null, filtros = null, fields = null, sort = null) {
    let headers = this.getHeaderLogado();

    let urlRelacionamentos = (relacionamentos) ? 'relations=' + JSON.stringify(relacionamentos) + '&' : '';
    let urlFiltros = (filtros) ? 'filters=' + JSON.stringify(filtros) + '&' : '';
    let urlFields = (fields) ? 'fields=' + JSON.stringify(fields) + '&' : '';
    let urlSort = (sort) ? 'sort=' + JSON.stringify(sort) + '&' : '';

    return this.http.get(this.url + '?' + urlRelacionamentos + urlFiltros + urlFields + urlSort, { headers })
      .map(res => {
        let json = res.json();
        if (json.Success) {
          this.trataSucesso(res);
        } else {
          this.trataErro(json);
        }
        return json;
      });

  }

  getPaginacao(pagina, limit, relacionamentos = null, filtros = null, fields = null, sort = null) {
    let headers = this.getHeaderLogado();
    let urlRelacionamentos = (relacionamentos) ? 'relations=' + JSON.stringify(relacionamentos) + '&' : '';
    let urlFiltros = (filtros) ? 'filters=' + JSON.stringify(filtros) + '&' : '';
    let urlFields = (fields) ? 'fields=' + JSON.stringify(fields) + '&' : '';
    let urlSort = (sort) ? 'sort=' + JSON.stringify(sort) + '&' : '';

    return this.http.get(this.url + '?' + urlRelacionamentos + urlFiltros + urlFields + urlSort + 'pages={"page":' + pagina + ',"limit":' + limit + '}', { headers })
      .map(res => {
        let json = res.json();
        if (json.Success) {
          this.trataSucesso(res);
        } else {
          this.trataErro(json);
        }
        return json;
      });

  }

  getById(id, relacionamentos = null, filtros = null) {
    let headers = this.getHeaderLogado();

    let urlRelacionamentos = '';
    let urlFiltros = '';

    if (relacionamentos) {
      urlRelacionamentos = 'relations=' + JSON.stringify(relacionamentos) + '&';
    }

    if (filtros) {
      urlFiltros = 'filters=' + JSON.stringify(filtros) + '&';
    }

    return this.http.get(this.url + id + '/?' + urlRelacionamentos + urlFiltros, { headers })
      .map(res => {
        let json = res.json();
        if (json.Success) {
          this.trataSucesso(res);
        } else {
          this.trataErro(json);
        }
        return json;
      });
  }

  adicionar(elem) {
    let headers = this.getHeaderLogado();

    return this.http.post(this.url, JSON.stringify(elem), { headers })
      .map(res => {
        let json = res.json();
        if (json.Success) {
          this.trataSucesso(res);
        } else {
          this.trataErro(json);
        }
        return json;
      });
  }

  editar(elem, id) {
    let headers = this.getHeaderLogado();

    return this.http.put(this.url + id, JSON.stringify(elem), { headers })
      .map(res => {
        let json = res.json();
        if (json.Success) {
          this.trataSucesso(res);
        } else {
          this.trataErro(json);
        }
        return json;
      });
  }

  apagar(id) {
    let headers = this.getHeaderLogado();

    return this.http.delete(this.url + id, { headers })
      .map(res => {
        let json = res.json();
        if (json.Success) {
          this.trataSucesso(res);
        } else {
          this.trataErro(json);
        }
        return json;
      });
  }

  getHeaderLogado() {
    let headers = new Headers();
    headers.append('Content-Type', 'application/json');
    headers.append('Authorization', localStorage.getItem('token'));

    return headers;
  }

  trataErro(json) {
    // exibe mensagens de erro
    this.func.showErro(json.Message);
  }

  trataSucesso(res) {
    let json = res.json();

    // guarda token
    let token = res.headers.get('Authorization');
    if (token && token.length) {
      console.log('Token encontrado no header:', token);
      localStorage.setItem('token', token);
    } else {
      console.warn('Token NÃO encontrado no header Authorization. Verificando corpo da resposta...');
      if (json.token) {
        token = json.token;
      } else if (json.Payload && json.Payload[0] && json.Payload[0].token) {
        token = json.Payload[0].token;
      }

      if (token) {
        console.log('Token encontrado no corpo da resposta:', token);
        localStorage.setItem('token', token);
      } else {
        console.error('Falha crítica: Token não encontrado em lugar nenhum.');
      }
    }

    // exibe mensagens de sucesso
    this.func.showSucesso(json.Message);
  }

  buscarTermografosPorNumero(tipoSource: string, numero: string) {
    let headers = this.getHeaderLogado();
    let urlBase = this.dominio + "/adm/" + tipoSource + "/";
    let urlFiltros = 'filters=' + JSON.stringify({ numero: numero }) + '&';

    return this.http.get(urlBase + '?' + urlFiltros, { headers })
      .map(res => {
        let json = res.json();
        if (json.Success) {
          this.trataSucesso(res);
        } else {
          this.trataErro(json);
        }
        return json;
      });
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/services/service.ts